import { useView, PLATFORM, autoinject } from 'aurelia-framework';
import { IAggregatedField } from '../overview-aggregation-component';

export interface IAggregatedFieldsDialogData {
  fields: IAggregatedField[];
  apply(fields: IAggregatedField[]): void;
}

@autoinject
@useView(PLATFORM.moduleName('agElements/overview-aggregation-component/aggregated-fields-dialog/aggregated-fields-dialog.html'))
export class AggregatedFieldsDialog {
  data: IAggregatedFieldsDialogData;

  activate(data: IAggregatedFieldsDialogData) {
    this.data = data;
  }

  // Applied as the dialog starts closing, so the status bar does not wait for the close animation.
  closing(action: string) {
    if (action === 'ok') {
      this.data.apply(this.data.fields);
    }
  }

  setDefault() {
    this.data.fields.forEach(x => {
      x.show = x.defaultShow;
    });
  }
}
